export const HELP_CONTENT = `
This panel displays activity and engagement data for the selected user.

### Statistics

| Field | Description |
|---|---|
| **Total Purchases** | Total completed property purchases across both live and online auctions (lifetime). |
| **Participation** | *(Not yet implemented.)* |
| **Active Reg.** | Number of online auctions this user is currently registered for. |
| **Active Bids** | Number of online auctions where this user currently has at least one active bid (auction count, not individual bid count). |
| **Active Closings** | Number of contracts currently in progress between winning bid and close of escrow. |

### User Info

| Field | Description |
|---|---|
| **Experience** | System-derived buyer persona based on auction history. Values: Novice, Bidder, Buyer, Trusted Buyer, or First-Time. |
| **Signup** | Date the user's account was created. |
| **Last Purchase** | Most recent completed purchase date across live and online auctions. |

### Live Auctions

| Field | Description |
|---|---|
| **Last registration** | Date of the user's most recent registration for a live (in-person) auction venue. |
| **Last bid** | Date of the user's most recent bid at a live (in-person) auction. |
| **Purchases total** | Total completed live auction purchases (lifetime). |

### Online Auctions

| Field | Description |
|---|---|
| **Last registration** | Date of the user's most recent online auction registration. |
| **Last bid** | Date of the user's most recent bid in an online auction. |
| **Purchases total** | Total completed online auction purchases (lifetime). |

### Bid to Close

| Field | Description |
|---|---|
| **Online bids** | Number of distinct online auctions where this user currently has at least one bid (auction count, not bid count). |
| **Quality bids** | Number of distinct online auctions where this user's current bid meets or exceeds 70% of the reserve price. |
| **Wallet funds** | Available online bid deposit balance in the user's wallet (consumable funds). |
| **Contracts in progress** | Number of won auctions currently in the contract/closing pipeline. |
| **Avg win \u2192 close** | *(Not yet implemented.)* |
| **Fallouts** | Number of contracts that failed to close due to buyer-caused issues (lifetime, online auctions). Does not include seller- or system-caused cancellations. |

### Remote Bid Funds

| Field | Description |
|---|---|
| **Remote Approved** | Whether this user is approved to place remote bids at live auctions. |
| **Remote Bid Available** | Funds currently available for remote bidding at live auctions (consumable balance). |
`
